/* Giancarlo Paoli — regia del sito.
   Il modulo scrive attributi, e basta. Nessun requestAnimationFrame,
   nessun osservatore di progresso, nessun gestore di ridimensionamento,
   nessun will-change permanente. A pagina in scorrimento l'unico costo
   è il listener passivo della testata. */

(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('gp-motion')) return; // il gate ha già deciso
  root.dataset.gpReady = '1';                        // disinnesca il cane da guardia

  var MAX_CASCATA = 4;

  var io = new IntersectionObserver(entrati, {
    threshold: 0,
    rootMargin: window.innerHeight < 700 ? '0px 0px -8% 0px' : '0px 0px -12% 0px'
  });

  function entrati(voci) {
    for (var i = 0; i < voci.length; i++) {
      if (!voci[i].isIntersecting) continue;
      io.unobserve(voci[i].target);   // una volta sola: non si rianima mai
      mostra(voci[i].target, false);
    }
  }

  function scopri(el) {
    if (el.hasAttribute('data-gp-stagger')) {
      var passo = Math.min(parseInt(el.getAttribute('data-gp-stagger'), 10) || 70, 200);
      if (window.innerWidth < 750) passo = Math.round(passo * 0.78);
      var figli = el.querySelectorAll('[data-gp-item]');
      for (var i = 0; i < figli.length; i++) {
        figli[i].style.transitionDelay = Math.min(i, MAX_CASCATA - 1) * passo + 'ms';
        figli[i].setAttribute('data-gp-in', '');
      }
    }
    var r = parseInt(el.getAttribute('data-gp-delay'), 10);
    if (r) el.style.transitionDelay = r + 'ms';
    el.setAttribute('data-gp-in', '');
  }

  /* ------------------------------------------------- la rete di sicurezza

     IntersectionObserver non si accorge di un elemento che passa da "sotto
     la finestra" a "sopra la finestra" in un solo salto, e quel salto
     succede davvero: link ad ancora, scorrimento a inerzia sul telefono,
     posizione ripristinata tornando indietro, ricerca nella pagina. Senza
     rete quel contenuto resterebbe invisibile per sempre, che è un difetto
     peggiore di qualunque animazione mancata.

     È una passata legata al tempo e non al frame: deve funzionare anche
     quando il browser sospende i frame perché la scheda è in secondo piano.
     Costa un getBoundingClientRect per elemento ancora in attesa, e la
     lista si svuota da sola. */

  var attesa = [];

  function mostra(el, subito) {
    if (subito) el.setAttribute('data-gp-secco', '');
    scopri(el);
    var i = attesa.indexOf(el);
    if (i > -1) attesa.splice(i, 1);
    if (subito) {
      setTimeout(function () { el.removeAttribute('data-gp-secco'); }, 60);
    }
  }

  var ultimaPassata = 0;
  function rete() {
    var ora = Date.now();
    if (ora - ultimaPassata < 120) return;
    ultimaPassata = ora;
    var h = window.innerHeight;
    for (var i = attesa.length - 1; i >= 0; i--) {
      var el = attesa[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < 0) { io.unobserve(el); mostra(el, true); }        // scavalcato
      else if (r.top < h * 0.92 && r.bottom > 0) { io.unobserve(el); mostra(el, false); }
    }
  }

  function scansiona(ambito) {
    var nodi = (ambito || document).querySelectorAll('[data-gp-reveal]:not([data-gp-in])');
    for (var i = 0; i < nodi.length; i++) {
      io.observe(nodi[i]);
      if (attesa.indexOf(nodi[i]) < 0) attesa.push(nodi[i]);
    }
    rete();
  }

  /* --------------------------------------------------------- la testata */

  var testata = document.querySelector('[data-gp-header]');
  if (testata) {
    var soglia = parseInt(testata.getAttribute('data-gp-header'), 10) || 60;
    var ultimo = window.scrollY;
    var campoAttivo = false;

    // Mentre un campo ha il fuoco la tastiera cambia l'altezza del viewport
    // e farebbe sparire la testata senza che nessuno abbia scorso.
    document.addEventListener('focusin', function (e) {
      campoAttivo = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName);
      if (campoAttivo) testata.removeAttribute('data-gp-hidden');
    });
    document.addEventListener('focusout', function () { campoAttivo = false; });

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > soglia) testata.setAttribute('data-gp-solid', '');
      else testata.removeAttribute('data-gp-solid');
      if (!campoAttivo && Math.abs(y - ultimo) > 8) {
        if (y > ultimo && y > 240) testata.setAttribute('data-gp-hidden', '');
        else testata.removeAttribute('data-gp-hidden');
        ultimo = y;
      }
    }, { passive: true });
  }

  /* ------------------------------------------------ interruttore nel piede */

  var interruttore = document.querySelector('[data-gp-motion-toggle]');
  if (interruttore) {
    interruttore.addEventListener('click', function () {
      try {
        localStorage.setItem('gp-motion', root.classList.contains('gp-motion') ? 'off' : 'on');
      } catch (e) {}
      location.reload();  // niente smontaggio parziale: si riparte pulito
    });
  }

  /* ------------------------------------------------ ciclo di vita Shopify */

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { scansiona(e.target); });
    // Nell'editor una sezione selezionata non deve mai apparire vuota.
    document.addEventListener('shopify:section:select', function (e) {
      var nodi = e.target.querySelectorAll('[data-gp-reveal]');
      for (var i = 0; i < nodi.length; i++) scopri(nodi[i]);
    });
    document.addEventListener('shopify:section:reorder', function () { scansiona(); });
  }

  // Tornando indietro dalla cache del browser la pagina non riesegue nulla.
  window.addEventListener('pageshow', function (e) { if (e.persisted) scansiona(); });

  window.addEventListener('scroll', rete, { passive: true });
  scansiona();
  window.GPMotion = { aggiorna: scansiona, scopri: scopri };
})();
